import { createContext } from "react";

export interface ConfirmParams {
  title: string;
  body?: string;
  okText?: string;
  cancelText?: string;
  onCancel?: () => void;
  /**
   * Returns true to leave the `Confirm` modal open
   */
  onOk: (message?: string) => Promise<boolean | void>;
  showMessageField?: boolean;
  messageRequired?: boolean;
  messageFieldName?: string;
}

interface LayoutContextType {
  confirm: (confirmParams: ConfirmParams) => void;
  notify: (
    type: "success" | "error" | "info",
    message: string,
    milliseconds?: number
  ) => void;
  setGlobalLoading: (globalLoadingState: boolean) => void;
}

const LayoutContext = createContext<LayoutContextType>({
  confirm: () => {},
  notify: () => {},
  setGlobalLoading: () => {}
});

export default LayoutContext;
